import { useState } from "react"

import {
  SortingLabels,
  SortingSelect,
} from "@/domains/auctions/view/sorting-select"
import { ViewSwitch } from "@/domains/auctions/view/view-switch"
import { CSS } from "@/stitches"
import { Box } from "@/ui/box"
import { Title } from "@/ui/text"

import { AuctionPreview, Sorting, sortAuctions } from "../model"
import * as Bar from "./bar"
import { AuctionsGrid, AuctionsGridProps } from "./grid"

type GridSectionProps = {
  title?: string
  auctions?: Array<AuctionPreview>
  loading?: boolean
  emptyMessage?: string
  gridProps?: Omit<AuctionsGridProps, "auctions">
  css?: CSS
  barProps?: {
    sorting?: Sorting
    onSortingChange?: (sorting: Sorting) => void
    sortingLabels?: SortingLabels
  }
}

export function AuctionsGridSection(props: GridSectionProps) {
  const [sorting, setSorting] = useState<Sorting>("default")

  const auctions = props.auctions ? sortAuctions(props.auctions, sorting) : null

  return (
    <Box as="section" css={props.css}>
      {!props.loading && (
        <Bar.Root css={{ mb: "$8" }}>
          <Bar.Left>
            <Title as="h2">{props.title}</Title>
          </Bar.Left>
          <Bar.Right>
            <ViewSwitch />
            <SortingSelect
              value={props.barProps?.sorting ?? sorting}
              onValueChange={props.barProps?.onSortingChange ?? setSorting}
              labels={props.barProps?.sortingLabels}
            />
          </Bar.Right>
        </Bar.Root>
      )}
      <AuctionsGrid
        auctions={auctions}
        loading={props.loading}
        {...props.gridProps}
      />
    </Box>
  )
}
